export default {
  qualification: [
    {
      name: '高新技术企业',
      cover: require('@/assets/images/honor/qualification/001.png')
    },
    {
      name: '技术先进型服务企业',
      cover: require('@/assets/images/honor/awards/006.png')
    },
    {
      name: 'CMMI L5认证',
      cover: require('@/assets/images/honor/qualification/CMMI-L5.png')
    },
    {
      name: 'ISO 27001认证',
      cover: require('@/assets/images/honor/qualification/ISO-27001.png')
    },
    {
      name: 'ISO 9001认证',
      cover: require('@/assets/images/honor/qualification/ISO-9001.png')
    },
  ],
  awards: [
    {
      name: '软件外包协会会长单位',
      cover: require('@/assets/images/honor/qualification/002.png')
    },
    {
      name: '最佳协同合作（大中华市场）金奖',
      cover: require('@/assets/images/honor/awards/001.png')
    },
    {
      name: '2009年香港资讯科技奖最佳合作奖',
      cover: require('@/assets/images/honor/awards/002.png')
    },
    {
      name: '最佳软件技术创新产品',
      cover: require('@/assets/images/honor/awards/003.png')
    },
    {
      name: 'MTR香港资讯科技优秀奖',
      cover: require('@/assets/images/honor/awards/005.png')
    },
    {
      name: '广东省守合同重信用企业',
      cover: require('@/assets/images/honor/awards/007.png')
    },
    {
      name: '广东省重点软件出口企业',
      cover: require('@/assets/images/honor/awards/008.png')
    },
    // {
    //   name: '广东省服务外包重点培育企业',
    //   cover: require('@/assets/images/honor/awards/008.png')
    // },
  ],
  intellectualProperty: [
    {
      name: '实训邦',
      cover: require('@/assets/images/honor/intellectual_property/002.png')
    },
    {
      name: '自动化测试平台',
      cover: require('@/assets/images/honor/intellectual_property/001.png')
    },
    {
      name: '智慧养老管理系统',
      cover: require('@/assets/images/honor/intellectual_property/006.jpg')
    },
    {
      name: '轨道交通行业内部信息发布管理系统',
      cover: require('@/assets/images/honor/intellectual_property/003.jpg')
    },
    {
      name: '粮油生产物联网系统',
      cover: require('@/assets/images/honor/intellectual_property/004.jpg')
    },
    {
      name: '设备安全维保管理系统',
      cover: require('@/assets/images/honor/intellectual_property/005.jpg')
    },
  ]
}


// WEBPACK FOOTER //
// ./src/views/aboutus/honor/data.js